/* tslint:disable */
/* eslint-disable */
/**
 * Melco Rest Services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    MelcoModelsColorCollection,
    MelcoModelsColorCollectionFromJSON,
    MelcoModelsColorCollectionFromJSONTyped,
    MelcoModelsColorCollectionToJSON,
    MelcoModelsCustomWarning,
    MelcoModelsCustomWarningFromJSON,
    MelcoModelsCustomWarningFromJSONTyped,
    MelcoModelsCustomWarningToJSON,
} from './';

/**
 * 
 * @export
 * @interface MelcoModelsGenericList1MelcoModelsColorCollection
 */
export interface MelcoModelsGenericList1MelcoModelsColorCollection {
    /**
     * 
     * @type {Array<MelcoModelsColorCollection>}
     * @memberof MelcoModelsGenericList1MelcoModelsColorCollection
     */
    list: Array<MelcoModelsColorCollection>;
    /**
     * 
     * @type {Array<MelcoModelsCustomWarning>}
     * @memberof MelcoModelsGenericList1MelcoModelsColorCollection
     */
    warning_list?: Array<MelcoModelsCustomWarning> | null;
    /**
     * 
     * @type {number}
     * @memberof MelcoModelsGenericList1MelcoModelsColorCollection
     */
    total: number;
}

export function MelcoModelsGenericList1MelcoModelsColorCollectionFromJSON(json: any): MelcoModelsGenericList1MelcoModelsColorCollection {
    return MelcoModelsGenericList1MelcoModelsColorCollectionFromJSONTyped(json, false);
}

export function MelcoModelsGenericList1MelcoModelsColorCollectionFromJSONTyped(json: any, ignoreDiscriminator: boolean): MelcoModelsGenericList1MelcoModelsColorCollection {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'list': ((json['list'] as Array<any>).map(MelcoModelsColorCollectionFromJSON)),
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(MelcoModelsCustomWarningFromJSON)),
        'total': json['total'],
    };
}

export function MelcoModelsGenericList1MelcoModelsColorCollectionToJSON(value?: MelcoModelsGenericList1MelcoModelsColorCollection | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'list': ((value.list as Array<any>).map(MelcoModelsColorCollectionToJSON)),
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(MelcoModelsCustomWarningToJSON)),
        'total': value.total,
    };
}


